import Card from '../../../shared/Card';
import Input from '../../../shared/Input';
import Header from '../../../shared/Header';
import { FormStack, Stack } from '../../../shared/layouts';
import { useTranslation } from 'react-i18next';
import useIconLibrary from "../../../../hooks/useIconLibrary";

const CompanyBlock = ({ company }) => {
  const { t } = useTranslation();
  const { HouseIcon } = useIconLibrary();

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={t('Bedrijfsgegevens')}
          icon={<HouseIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={true}>
          <Input
            label={t('Bedrijfsnaam')}
            value={company?.name}
            readOnly={true}
          />
          <Input
            label={t('KvK-nummer')}
            value={company?.kvk_number}
            readOnly={true}
          />
          <Input
            label={t('Telefoonnummer')}
            value={company?.phone_number}
            readOnly={true}
          />
          <Input
            label={t('E-mail')}
            value={company?.email}
            readOnly={true}
          />
        </FormStack>
      </Stack>
    </Card>
  );
};

export default CompanyBlock;
